<template>
  <el-dialog title="新增" :close-on-click-modal="false" :visible.sync="visible"
    @closed="reset">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="auto">
        <el-form-item label="服务器名" :label-width="formLabelWidth" prop="name">
          <el-input v-model="dataForm.name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="服务器IP" :label-width="formLabelWidth" prop="hostname">
          <el-input v-model="dataForm.hostname" :disabled="isEditMode" autocomplete="off" />
        </el-form-item>
        <el-form-item label="协议类型" :label-width="formLabelWidth" prop="protocol">
           <el-select v-model="dataForm.protocol" placeholder="RDP"  value="0">
            <el-option label="RDP" value="0" />
            <el-option label="VNC" disabled value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="端口号" :label-width="formLabelWidth" prop="port">
          <el-input v-model="dataForm.port" autocomplete="off" />
        </el-form-item>
        <el-form-item label="操作系统" :label-width="formLabelWidth" prop="os">
           <el-select v-model="dataForm.os" placeholder="Windows"  value="Windows">
            <el-option label="Windows" value="Windows" />
            <el-option label="Linux" disabled value="Linux" />
          </el-select>
        </el-form-item>
        <el-form-item label="管理员用户" :label-width="formLabelWidth" prop="admin_username">
          <el-input v-model="dataForm.admin_username"  autocomplete="off" />
        </el-form-item>
        <el-form-item label="管理员密码" :label-width="formLabelWidth" prop="admin_password">
          <el-input v-model="dataForm.admin_password"  autocomplete="off" />
        </el-form-item>
        <el-form-item label="关联账户" :label-width="formLabelWidth" prop="account_id">
          <el-cascader
            :options="options"
            v-model="dataForm.account_id"
            :props="{ emitPath: false, expandTrigger: 'hover' }"
            filterable
            clearable />
        </el-form-item>
        <el-form-item label="状态" :label-width="formLabelWidth" prop="is_lock">
          <el-radio-group v-model="dataForm.is_lock">
            <el-radio :label="0">正常</el-radio>
            <el-radio :label="1">锁定</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
          <el-input v-model="dataForm.remark" autocomplete="off" />
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="dataFormSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { MessageBox, Message } from 'element-ui'
import { validateIP } from '../../utils/validation'
import { eventBus } from '@containers/WinRD/utils/eventBus' // 全局事件总线

export default {
  data () {
    return {
      visible: false,
      submitLoading: false,
      appTypeList: [],
      linkUserList: [],
      is_lock: [
        { id: 0, name: '正常' },
        { id: 1, name: '异常' },
      ],
      dataForm: {
        name: '',
        hostname: '',
        protocol: '0',
        port: '3389',
        os: 'Windows',
        admin_username: '',
        admin_password: '',
        account_id: null,
        is_lock: 0,
        remark: '',
      },
      dataRule: {
        name: [{
          required: true,
          message: '请输入服务器名',
          trigger: 'blur',
        }],
        hostname: [{
          required: true,
          message: '请输入服务器IP',
          trigger: 'blur',
        },
        { validator: validateIP, trigger: 'blur' },
        ],
        protocol: [{
          required: true,
          message: '请选择协议',
          trigger: 'blur',
        }],
        port: [{
          required: true,
          message: '请输入端口',
          trigger: 'blur',
        }],
        admin_username: [{
          required: true,
          message: '请输入管理员用户名',
          trigger: 'blur',
        }],
        admin_password: [{
          required: true,
          message: '请输入管理员密码',
        }],
        account_id: [{
          required: true,
          message: '请选择关联账户',
          trigger: 'blur',
        }],
      },
    }
  },
  methods: {
    init (row, appTypeList) {
      this.visible = true
      this.appTypeList = appTypeList
      this.linkUser() // 获取关联账户列表
    },
    reset () {
      this.$refs.dataForm.resetFields()
    },

    // 关联账户列表获取
    async linkUser () {
      try {
        const response = await this.$http.get('/rdbackend/get_users')

        // 确保 response.data 是一个数组
        this.linkUserList = Array.isArray(response.data.data) ? response.data.data : []
        console.log(response.data)

        // 处理 options 数据
        this.options = this.linkUserList.map(domain => ({
          value: domain.domain_id,
          label: domain.project_domain,
          children: domain.user ? domain.user.map(user => ({
            value: user.id,
            label: user.displayname || user.name,
          })) : [],
        }))
      } catch (error) {
        console.error('There was an error!', error)
      }
    },

    // 表单提交
    async dataFormSubmit () {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          const tmp = { ...this.dataForm }

          this.$http.post('/rdbackend/add_remote', tmp, {
            headers: {
              'Content-Type': 'application/json',
            },
          }).then(response => {
            this.visible = false
            this.submitLoading = false
            this.$message({
              message: response.data.message,
              type: 'success',
              duration: 1500,
            })
            // 触发事件
            eventBus.$emit('refresh-list')
          }).catch(error => {
            this.$message({
              message: error.response.data.error,
              type: 'error',
              duration: 1500,
            })
            this.submitLoading = false
          })
        }
      })
    },
  },
}
</script>
